export default __webpack_public_path__ + "static/media/edit-icon.39350b5e.svg";